import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Post } from '@interfaces/api.post.interface';

@Component({
  selector: 'ark-ui-post',
  templateUrl: './ui-post.component.html',
  styleUrls: ['./ui-post.component.scss'],
})
export class UiPostComponent {
  @Input() post!: Post;

  @Output() postClicked = new EventEmitter<number>();
  @Output() postImageClicked = new EventEmitter<number>();
  constructor() {}
}
